(() => {
	angular
		.module('main')
		.controller('LeadsOverviewController', LeadsOverviewController)
		.filter(
			'capitalize',
			() =>
				function(input) {
					return angular.isString(input) && input.length > 0
						? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()
						: input;
				}
		);

	LeadsOverviewController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$timeout',
		'messageService',
		'timeService',
		'$routeParams',
		'timeConverter',
		'emailService',
		'templateRequestsService',
		'leadDataService',
		'clientService',
		'jobTypesDataService',
		'workflowDataService',
		'$window',
		'accountService',
		'settingsService'
	];

	function LeadsOverviewController(
		$scope,
		$rootScope,
		$location,
		$timeout,
		messageService,
		timeService,
		$routeParams,
		timeConverter,
		emailService,
		templateRequestsService,
		leadDataService,
		clientService,
		jobTypesDataService,
		workflowDataService,
		$window,
		accountService,
		settingsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$('body').updatePolyfill();
			let searchFromUrl;
			try {
				searchFromUrl = decodeURIComponent($routeParams.search);
				searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
			} catch (e) {
				searchFromUrl = '';
			}
			$scope.pageRequest = {
				page: +$routeParams.page || 0,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: $rootScope.leadPageRequest && $rootScope.leadPageRequest.pageOrder.predicate || 'createdAt',
					reverse: $rootScope.leadPageRequest && $rootScope.leadPageRequest.pageOrder.reverse || false
				},
				search: searchFromUrl || ''
			};
			$scope.pagindis = true;
			$scope.sendEmailLeadId = null;
			$scope.leads = [];
			$scope.workflowNames = [];
			$scope.jobTypes = [];
			$scope.totalItems = 0;
			$scope.selectActive = [
				'Open Leads',
				'Open Leads waiting for my reply',
				"Open Leads waiting for the client's reply",
				'Archived Leads'
			];
			$scope.mailData2Save = {};
			$scope.searchText = searchFromUrl || '';
			$scope.pageRequest.search = searchFromUrl || '';
			$scope.unsubscribe = new Rx.Subject();
			$scope.changeUrl = false;
			$scope.toSearch = true;

			subscribeToCustomizeLabelsChange();
			getCompanyId();
		});

		$window.onpopstate = (...e) => {
			$scope.changeUrl = false;
			let searchFromUrl;
			if ($routeParams.search) {
				try {
					searchFromUrl = decodeURIComponent($routeParams.search);
					searchFromUrl = searchFromUrl === 'undefined' ? '' : searchFromUrl;
				} catch (e) {
					searchFromUrl = '';
				}
				$scope.pageRequest.search = searchFromUrl || '';
				$scope.searchText = searchFromUrl || '';
			} else {
				$scope.pageRequest.search = '';
				$scope.searchText = '';
				$scope.toSearch = false;
			}
			getResultsPage(+$routeParams.page);
		};

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		const defaultWorkflow = {
			id: null,
			name: 'Default'
		};

		$scope.isCreateLeadSpinningWheelActive = false;

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(customizeLabels => {
					$scope.mainShootLabelName = customizeLabels.mainShootLabel;
					$scope.extraShootLabelName = customizeLabels.extraShootLabel;
					$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				});
		}

		$scope.$watch('selectActiveLeads', (newValue, oldValue) => {
			if (!oldValue || oldValue === newValue) {
				return false;
			}
			switch (newValue) {
				case 'Open Leads':
					getResultsPage(
						$scope.pageRequest.page,
						$scope.pageRequest.perPage,
						null,
						null,
						'open'
					);
					break;
				case 'Open Leads waiting for my reply':
					getResultsPage(
						$scope.pageRequest.page,
						$scope.pageRequest.perPage,
						null,
						null,
						'open_waiting_user_reply'
					);
					break;
				case "Open Leads waiting for the client's reply":
					getResultsPage(
						$scope.pageRequest.page,
						$scope.pageRequest.perPage,
						null,
						null,
						'open_waiting_client_reply'
					);
					break;
				case 'Archived Leads':
					getResultsPage(
						$scope.pageRequest.page,
						$scope.pageRequest.perPage,
						null,
						null,
						'archived'
					);
					break;
				default:
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			}
		});

		let timerId;

		$scope.$watch('searchText', (newValue, oldValue) => {
			if (newValue == null) {
				return;
			}
			if (oldValue == newValue) {
				return;
			}
			if (!$scope.toSearch) {
				$scope.toSearch = true;
				return;
			}
			if (newValue.length > 0) {
				if (timerId != null) {
					clearTimeout(timerId);
				}
				timerId = setTimeout(searchRequest, 500);
			} else {
				clearTimeout(timerId);
				if (newValue.length == 0) {
					$scope.pageRequest.search = '';
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
			}
		});

		function searchRequest() {
			$scope.pageRequest.search = $scope.searchText;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};
		$scope.getElement = function(index) {
			const tableId = document
				.getElementById('tableId')
				.getBoundingClientRect();
			const dotsMenu = document
				.getElementById(`dotsMenu-${index}`)
				.getBoundingClientRect();
			const add = document.getElementsByClassName(`dropdown-menu-${index}`);
			add[0].style.transform = '';
			// 165-height of modal; 30-height of 3 dots menu
			const x = dotsMenu.top - tableId.top;
			const value = tableId.height - x;
			if (tableId.height > 165 && value < 165) {
				add[0].style.transform = `translate(-20%, ${value}px)`;
			}
		};
		$scope.isFilterAllowed = function(filter) {
			if (!$scope.allowedFilters) {
				return false;
			}

			return $scope.allowedFilters.includes(filter);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};

		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 0) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};

		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					($scope.pageRequest.page + 1) * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.showLead = function(id) {
			$location.path(`leads/view/${id}`);
		};

		$scope.archivedLead = leadId => {
			leadDataService.archiveLead(leadId).subscribe(
				() => {
					messageService.showToaster('s_5', 'lead');
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				},
				error => {
					const { errorMessage } = error.error;
					if (errorMessage.includes('Lead contains invoices.')) {
						messageService.showToaster('e_4', 'lead');
					} else {
						messageService.showDefaultErrorMessage(error);
					}
				}
			);
		};

		$scope.unArchivedLead = leadId => {
			leadDataService.unarchiveLead(leadId).subscribe(
				() => {
					messageService.showToaster('s_6', 'lead');
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				},
				error => {
					messageService.showDefaultErrorMessage(error);
				}
			);
		};

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null,
			filter = null
		) {
			let changed = false;
			let perPageChanged = false;

			if (predicate) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = !!reverse;
				changed = true;
			}
			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				$scope.pageRequest.page = 0;
				changed = true;
				perPageChanged = true;
			}
			if (pageNumber !== null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}
			if (filter) {
				$scope.pageRequest.filter = filter;
				$scope.pageRequest.page = 0;
				setFilter(filter);
				changed = true;
			}
			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				console.log('out of page');
				$scope.pageRequest.page = 0;
			}

			if (changed) {
				leadDataService
					.getLeadsOnPageV2($scope.pageRequest, perPageChanged)
					.subscribe(
						data => successGetResultsPage(data),
						err => messageService.showDefaultErrorMessage(err)
					);
			}
		}

		function successGetResultsPage(data) {
			if (data) {
				$scope.pageRequest.search = $scope.searchText;
			}

			$scope.pageRequest.searchToken = data.searchToken;

			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.totalSize : 0;

			let pagesCount;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (let i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}
			$scope.leads = JSON.parse(JSON.stringify(data.items));

			$scope.allowedFilters = data.sortingFields;
			$rootScope.leadPageRequest = $scope.pageRequest;
			let newSearch;
			try {
				newSearch = encodeURIComponent($scope.pageRequest.search);
				newSearch = newSearch === 'undefined' ? null : newSearch;
			} catch (error) {
				newSearch = ''
			}
			if ($scope.changeUrl) {
				$location.search({
					page: $scope.pageRequest.page,
					search: newSearch || null
				});
			}
			$scope.changeUrl = true;

			$scope.$evalAsync();
		}

		// Edit
		function showNewLeadModal() {
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.isCreateJobSpinnningWheelActive = true;
			prepareLead($scope.newJob);
		}

		$scope.createLead = () => {
			$scope.isCreateLeadSpinningWheelActive = true;
			$scope.newLead = {};
			$scope.clients = [];
			$scope.showSecondClient = false;
			showNewLeadModal();
		};

		function prepareLead() {
			$scope.clients = [];

			const {
				startDate,
				finishDate,
				primaryContact,
				secondaryContact,
				workflow
			} = $scope.newLead;

			$scope.newLead.oldWorkflow = workflow;

			if (!startDate && !finishDate) {
				$scope.newLead.hasNoDate = !!$scope.newLead.id;
			} else {
				$scope.newLead.hasNoDate = false;
				if (startDate) {
					$scope.newLead.startDate = timeService.createDateAsUTC(startDate);
				}
				if (finishDate) {
					$scope.newLead.finishDate = timeService.createDateAsUTC(finishDate);
				}
			}

			if (primaryContact) {
				const primaryClientSearchText = clientService.fillClientSearchText(
					primaryContact
				);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newLead.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				const secondaryClientSearchText = clientService.fillClientSearchText(
					secondaryContact
				);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newLead.secondaryContact = $scope.clients[1];
			}
			if (
				$scope.newLead.startDate &&
				($scope.newLead.startTime === null ||
					$scope.newLead.finishTime === null)
			) {
				$scope.newLead.allday = true;
			}
			const type = $scope.newLead.type;
			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isCreateJobSpinnningWheelActive = false;
				})
				.subscribe(() => {
					$timeout(() => {
						$scope.newLead.type = type;
						$('#newLead').modal('show');
						$scope.isCreateJobSpinnningWheelActive = false;
						$scope.$broadcast('showModal', {
							lead: $scope.newLead,
							jobId: $scope.newLead.jobId
						});
					}, 300);
				});
		}
		function getJobTypes() {
			return jobTypesDataService
				.getJobTypes()
				.map(data => successGetJobTypes(data));
		}

		function successGetJobTypes(data) {
			$scope.newLead.jobTypes = angular.copy(data);
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService
				.getWorkflowAndLanguageNames()
				.map(data => successGetWorkflowAndLanguageNames(data));
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.newLead.workflowNames = angular.copy(data.workflows);
			$scope.newLead.languageNames = angular.copy(data.languages);
		}

		$scope.editLeadModal = index => {
			$scope.button_disable = true;
			$scope.newLead = angular.copy($scope.leads[index]);
			prepareLead($scope.newLead);

			if ($scope.newLead.startTime) {
				$scope.newLead.startTime = timeConverter.convert24to12(
					$scope.newLead.startTime
				);

				$scope.newLead.finishTime = timeConverter.convert24to12(
					$scope.newLead.finishTime
				);
			}
		};

		function getSelectActiveLeads() {
			const activeFilter = getDefaultFilter();
			let selectActiveOption;
			switch (activeFilter) {
				case 'open':
					selectActiveOption = $scope.selectActive[0];
					break;
				case 'open_waiting_user_reply':
					selectActiveOption = $scope.selectActive[1];
					break;
				case 'open_waiting_client_reply':
					selectActiveOption = $scope.selectActive[2];
					break;
				case 'archived':
					selectActiveOption = $scope.selectActive[3];
					break;
				default:
					selectActiveOption = $scope.selectActive[0];
					break;
			}

			return selectActiveOption;
		}

		function getCompanyId() {
			accountService.companyIdObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(data => {
					$scope.companyId = data;
					$scope.selectActiveLeads = getSelectActiveLeads();
					$scope.pageRequest.filter = getDefaultFilter();
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				});
		}

		function getDefaultFilter() {
			const filter = $window.localStorage.getItem(
				`leadsOverviewFilter${$scope.companyId}`
			);

			return filter || setFilter();
		}

		function setFilter(optionFilter = 'open') {
			$window.localStorage.setItem(
				`leadsOverviewFilter${$scope.companyId}`,
				optionFilter
			);

			return optionFilter;
		}

		// Email methods
		$scope.retrySendMail = function() {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
			emailService.callLastEmailFn();
		};

		$scope.showSendEmailModal = function(leadId, contact, secondaryContact) {
			$scope.showSendEmailModalSpinningWheel = true;

			Rx.Observable.zip(
				templateRequestsService.getTemplates('general_preview'),
				templateRequestsService.getTemplates('email_signature')
			)
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.showSendEmailModalSpinningWheel = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				})
				.subscribe(([emails, mailSignature]) => {
					$scope.mailData2Save = angular.copy(contact);
					if (secondaryContact) {
						$scope.mailData2Save.secondaryEmail = secondaryContact.email;
					}
					$scope.mailData2Save.emails = emails;
					$scope.mailData2Save.mailSignature = mailSignature.signature || '';

					$rootScope.clientToken = false;

					if (!$scope.$$phase) {
						$scope.$apply();
					}
					$routeParams.leadId = leadId;
					$scope.leadId = leadId;
					$scope.sendEmailLeadId = leadId || null;
					$('#sendContactEmailModal').modal('show');
				});
		};

		$scope.setEmail = function(site, object) {
			let stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(
				stringEmail.indexOf('(') + 1,
				stringEmail.length - 1
			);

			if (!object) {
				$scope.sendMessage.emailCc = stringEmail;
			} else {
				object.emailCc = stringEmail;
			}
		};

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
				$scope.$evalAsync();
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				clearQuestAttachments();
				clearContractAttachments();
			}
		};
		function clearQuestAttachments() {
			$scope.attachmentsDataQueston = {
				attachments: [],
				filesSize: 0
			};
		}

		function clearContractAttachments() {
			$scope.attachmentsDataContract = {
				attachments: [],
				filesSize: 0
			};
		}
		// Delete
		$scope.showDeleteModal = leadId => {
			$scope.leadForDelete = leadId;
			$('#deleteModal').modal('show');
		};

		$scope.deleteLead = () => {
			$scope.deleteDisable = true;

			leadDataService
				.deleteLead($scope.leadForDelete)
				.finally(() => ($scope.deleteDisable = false))
				.subscribe(
					() => {
						messageService.showToaster('s_2', 'lead');

						$('#deleteModal').modal('hide');
						getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
					},
					error => errorDeleteLead(error)
				);
		};

		function errorDeleteLead({ status, data }) {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && errorMessage) {
				if (
					errorMessage.includes(
						'This payment cannot be marked as unpaid because it was overpaid in Xero.'
					)
				) {
					errorCode = 'e_12';
					errorPlace = 'xero';
					value = 'job';
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}
		$rootScope.updateLeadView = function() {
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/lead/leadOverviewController.js